// Import dependencies
import { unsafeCSS, css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';

// Import style for web component
import styles from './web-component-style.scss';

// Get translatable strings
const strings = UncannyAutomatorBackend.logs.components.log.i18n.actions;

// eslint-disable-next-line require-jsdoc
@customElement( 'uap-log-header-action-edit-recipe' )
export class AutomatorLogHeaderActionEditRecipe extends LitElement {
	// Define style
	static styles = css`${ unsafeCSS( styles ) }`;

	// The link to edit the recipe
	@property( { type: String, attribute: 'recipe-edit-url' } ) accessor recipeEditURL;

	// eslint-disable-next-line require-jsdoc
	render() {
		return html`
			<uo-tooltip>
				<span class="tooltip-nowrap">${ strings.editRecipe }</span>

				<uo-button
					slot="target"
					color="transparent"
					size="small"

					target="_blank"
					href="${ this.recipeEditURL }"
				>
					<uo-icon id="pencil" size="16"></uo-icon>
				</uo-button>
			</uo-tooltip>
		`;
	}
}